import datos from "src/services/datos";
import Swal from "sweetalert2";

const generos = new datos("genero");

export const getGeneros = async (auth) => {
  generos.addCondition("genero", "id", 0, ">");
  const response = await generos.get();
  return response.wsResponse.genero;
};

export const getGenerosPaginated = async (limit, offset) => {
  generos.addCondition("genero", "id", 0, ">");
  generos.addLimitCondition(limit, offset);
  const response = await generos.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: [...response.wsResponse.genero],
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const postGenero = async (genero) => {
  if (genero) {
    const data = {
      id: genero.id,
      nombre: genero.detalle,
    };
    const response = await generos.insert(data);
    return response;
  }
  return false;
};

export const deleteGenero = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este genero?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {

      const userData = new datos('genero');
      let data = {
        id: id
      }
      const response = await userData.delete(data);
      if (response.status === "true") {

        status = true;
        await Swal.fire(
          "Eliminado!",
          "El genero ha sido eliminado exitosamente.",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message
        });
      }
    }
  });
  return status;
};
